import { FC, HTMLAttributes } from 'react';
import { useSubject } from '../hooks';
import { BehaviorSubject, LanguageCode } from '../types';

export type AudioControllerProps = {
  language?: LanguageCode;
  url: (
    BehaviorSubject<string | null>
    | string
    | null
  );
} & Pick<HTMLAttributes<HTMLAudioElement>, 'onError'>;

export const AudioController: FC<AudioControllerProps> = ({
  language,
  url: urlProp,
  ...audioElementProps
}) => {
  const urlSubject = (urlProp instanceof BehaviorSubject) ? (
    urlProp
  ) : new BehaviorSubject<string | null>(urlProp);
  const url = useSubject<string | null>(urlSubject, urlSubject.value);

  return (!url) ? null : (
    <audio
      controls
      controlsList="nodownload"
      style={{ width: '100%' }}
      lang={language}
      src={url}
      {...audioElementProps}
    />
  );
};
